export const calendar = {
  title: 'عرض التقويم',
  subtitle: 'نظرة عامة مرئية على حجوزاتك',
  
  // Calendar navigation
  today: 'اليوم',
  month: 'شهر',
  week: 'أسبوع',
  day: 'يوم',
  list: 'قائمة',
  
  // Event types
  pickup: 'استلام',
  return: 'إرجاع',
  maintenance: 'صيانة',
  blocked: 'محجوب',
  
  // Actions
  addEvent: 'إضافة حدث',
  editEvent: 'تعديل الحدث',
  deleteEvent: 'حذف الحدث',
  viewDetails: 'عرض التفاصيل',
  
  // Time
  allDay: 'طوال اليوم',
  startTime: 'وقت البداية',
  endTime: 'وقت النهاية',
  
  // Messages
  noEvents: 'لا توجد أحداث',
  noEventsDesc: 'لا توجد أحداث مجدولة لهذه الفترة.',
  eventCreated: 'تم إنشاء الحدث بنجاح',
  eventUpdated: 'تم تحديث الحدث بنجاح',
  eventDeleted: 'تم حذف الحدث بنجاح',
}; 